import { TextService } from "../../Services/TextService";
import { EmailTemplateType } from "../../Types/EmailTemplate";
import previewClassic from "../../Images/EmailTemplatePreview/preview_1.png";
import previewMinimal from "../../Images/EmailTemplatePreview/preview_2.png";
import previewHeader from "../../Images/EmailTemplatePreview/preview_3.png";

type EmailDesignTemplateCardSelectProps = {
    value?: EmailTemplateType;
    onChange?: (value: EmailTemplateType) => void;
    onTemplateSelected?: (value: EmailTemplateType) => void;
};

export const EmailDesignTemplateCardSelect = (props: EmailDesignTemplateCardSelectProps) => {
    const GetText = TextService.GetText;

    const options = [
        {
            value: EmailTemplateType.Classic,
            title: GetText("CreateTemplate_DesignTemplateClassic"),
            description: GetText("CreateTemplate_DesignTemplateClassicDescription"),
            image: previewClassic,
        },
        {
            value: EmailTemplateType.Minimal,
            title: GetText("CreateTemplate_DesignTemplateMinimal"),
            description: GetText("CreateTemplate_DesignTemplateMinimalDescription"),
            image: previewMinimal,
        },
        {
            value: EmailTemplateType.Header,
            title: GetText("CreateTemplate_DesignTemplateHeader"),
            description: GetText("CreateTemplate_DesignTemplateHeaderDescription"),
            image: previewHeader,
        },
    ];

    const onSelect = (templateType: EmailTemplateType) => {
        props.onChange?.(templateType);
        props.onTemplateSelected?.(templateType);
    };

    return (
        <div
            style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "12px",
                alignItems: "flex-start",
            }}
        >
            {options.map((option) => {
                const selected = props.value === option.value;

                return (
                    <button
                        key={option.value}
                        type="button"
                        aria-pressed={selected}
                        onClick={() => onSelect(option.value)}
                        style={{
                            textAlign: "left",
                            border: selected ? "2px solid #1677ff" : "1px solid #d9d9d9",
                            borderRadius: "8px",
                            padding: "8px",
                            background: "#fff",
                            cursor: "pointer",
                            boxShadow: selected ? "0 0 0 2px rgba(22,119,255,0.2)" : "none",
                            width: "220px",
                        }}
                    >
                        <img
                            src={option.image}
                            alt={option.title}
                            style={{
                                height: "105px",
                                objectFit: "cover",
                                borderRadius: "6px",
                                border: "1px solid #f0f0f0",
                                marginBottom: "8px",
                            }}
                        />
                        <div style={{ fontWeight: 600, marginBottom: "4px" }}>{option.title}</div>
                        <div style={{ color: "#8c8c8c", fontSize: "12px", lineHeight: 1.35 }}>{option.description}</div>
                    </button>
                );
            })}
        </div>
    );
};

export default EmailDesignTemplateCardSelect;